import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-461bbee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Something went wrong", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Sorry. Devs are looking into it.", -1))
const _hoisted_4 = { class: "message" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  props: {
    error: null
  },
  setup(__props: any) {

const props = __props as { error: any };

const message = computed(() => {
  const e = props.error;

  if (!e) {
    return 'Unexpected error';
  }

  if (e.message) {
    return props.error.message;
  } else if (e.error) {
    return e.error;
  }
  return '';
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, "Message: " + _toDisplayString(_unref(message)), 1)
  ]))
}
}

})